import { z } from 'zod';

export const documentPermissionSchema = z
  .object({
    can_delete: z.boolean().optional(),
    can_edit: z.boolean().optional(),
    can_upload: z.boolean().optional(),
  })
  .transform((raw) => ({
    canDelete: raw.can_delete ?? true,
    canEdit: raw.can_edit ?? true,
    canUpload: raw.can_upload ?? false,
  }));

export const globalPermissionsSchema = z
  .object({
    can_create: z.boolean().optional(),
    can_upload_to_personal: z.boolean().optional(),
    can_create_in_personal: z.boolean().optional(),
  })
  .transform((raw) => ({
    canCreate: raw.can_create ?? true,
    canUploadToPersonal: raw.can_upload_to_personal ?? false,
    canCreateInPersonal: raw.can_create_in_personal ?? false,
  }));

export const documentsPermissionsResponseSchema = z
  .object({
    objects_permissions: z.record(z.string(), documentPermissionSchema).default({}),
    global_permissions: globalPermissionsSchema.optional(),
  })
  .transform(({ objects_permissions, global_permissions }) => ({
    permissions: objects_permissions,
    globalPermissions: global_permissions ?? {
      canCreate: true,
      canUploadToPersonal: false,
      canCreateInPersonal: false,
    },
  }));

export type DocumentPermission = z.infer<typeof documentPermissionSchema>;
export type GlobalPermissions = z.infer<typeof globalPermissionsSchema>;
export type DocumentsPermissionsResponse = z.infer<typeof documentsPermissionsResponseSchema>;
export type DocumentPermissionApi = z.input<typeof documentPermissionSchema>;
export type GlobalPermissionsApi = z.input<typeof globalPermissionsSchema>;
export type DocumentsPermissionsResponseApi = z.input<typeof documentsPermissionsResponseSchema>;
